import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_HOME_PAGE_WIDGET,
    getHomePageWidgetFail,
    getHomePageWidgetSuccess
} from '../action/getHomePageWidgetAction'

// api 
import getHomePageWidgetApi from '../api/getHomePageWidgetApi'

export function* getHomePageWidgetSaga(action) {
    try {
        const response = yield call(() => getHomePageWidgetApi(action.params))
        if (response.data.status === 1) {
            yield put(getHomePageWidgetSuccess(response, action))
        } else {
            yield put(getHomePageWidgetFail(response, action))
        }
    }
    catch (e) {
        yield put(getHomePageWidgetFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_HOME_PAGE_WIDGET, getHomePageWidgetSaga)
}